import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Slider from '@material-ui/core/Slider';
// import Typography from '@material-ui/core/Typography';

const Lunches = ({ classes, state, setState }) => {
  const [text, setText] = useState(state.quantityPreferences.lunchCount || 0);

  const update = (lunchCount) => {
    const q = state.quantityPreferences;
    let { newLunchCount } = q;
    if (lunchCount === 0) newLunchCount = 0;
    const diff = lunchCount - q.lunchCount;
    if (diff > 0) {
      newLunchCount += diff;
    }
    if (newLunchCount > lunchCount) {
      newLunchCount = lunchCount;
    }
    setText(lunchCount);
    setState({
      ...state,
      quantityPreferences: {
        ...q,
        lunchCount,
        newLunchCount,
      }
    });
  };

  const handleSliderChange = (event, lunches) => {
    update(lunches);
  };

  const handleInputChange = (event) => {
    setText(event.target.value);
  };

  const value = state.quantityPreferences.lunchCount || 0;

  const handleBlur = () => {
    let lunches;
    if (!text || isNaN(Number(text))) {
      lunches = 0;
    } else {
      lunches = Number(text);
    }
    if (lunches < 0) {
      lunches = 0;
    } else if (lunches > 7) {
      lunches = 7;
    }
    update(lunches);
  };

  return (
    <Grid container item>
      <Grid item xs={1} />
      <Grid container direction="column" item xs={11}>
        <Grid container item spacing={2}>
          <Grid item xs>
            <Slider
              valueLabelDisplay="auto"
              value={typeof value === 'number' ? value : 0}
              onChange={handleSliderChange}
              aria-labelledby="lunch-count"
              step={1}
              min={0}
              max={7}
            />
          </Grid>
          <Grid item xs>
            <Input
              className={classes.input}
              value={text}
              margin="dense"
              onChange={handleInputChange}
              onBlur={handleBlur}
              inputProps={{
                step: 1,
                min: 0,
                max: 7,
                type: 'number',
                'aria-labelledby': 'lunch-count',
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Lunches;
